import { Typography } from "./Typography";

/**
 * 各ページ共通の見出しコンポーネント
 * 英語グラデーション + 日本語テキスト
 */
export function SectionHeading({
  children,
  as = "h2",
  englishTitle,
}: {
  children: React.ReactNode;
  as?: "h1" | "h2";
  /** 英語タイトル（グラデーション表示） */
  englishTitle?: string;
}) {
  return (
    <div>
      {englishTitle && (
        <p
          className="font-bold tracking-[0.15em] uppercase text-sm md:text-base mb-0.5 bg-clip-text text-transparent"
          style={{
            fontFamily: "'Zen Kaku Gothic Antique', sans-serif",
            backgroundImage:
              "linear-gradient(90deg, var(--color-shegate-accent) 0%, #b22629 100%)",
          }}
        >
          {englishTitle}
        </p>
      )}
      <Typography
        as={as}
        font="antique"
        size={as === "h1" ? "3xl" : "2xl"}
        color="black"
        bold
        letterSpacing="1.5px"
      >
        {children}
      </Typography>
    </div>
  );
}
